import React from 'react';
import PropTypes from 'prop-types';

import { Wrapper } from './styles';

export default function IndexLayout({ children }) {
  return <Wrapper>{children}</Wrapper>;
}

IndexLayout.propTypes = {
  children: PropTypes.element.isRequired,
};
